




























































































































































































































































































































import Vue from 'vue'

import { Component, Prop, Watch } from 'vue-property-decorator'
import { required } from '@/utils/formValidations'
import {
  greaterDates,
  greaterOrEquals,
  lessOrEquals,
  maxLength,
  totalLength
} from '@/utils/ValidationUtil'
import Denuncia from '@/model/Denuncia'
import CargaMagistrado from '@/components/commons/CargaMagistrado.vue'
import CargaExpediente from '@/components/commons/CargaExpediente.vue'
import FechaSelect from '@/components/commons/FechaSelect.vue'
import { convertFechaInicio, showFecha } from '@/utils/DateUtil'
import Resolucion from '@/model/Resolucion'
import InvertedSpanTooltip from '@/components/commons/InvertedSpanTooltip.vue'
import { TIPO_COMISION } from '@/api/StaticApi'
import { mapToSelect } from '@/utils/SelectUtil'

@Component({
  components: {
    CargaMagistrado,
    CargaExpediente,
    FechaSelect,
    InvertedSpanTooltip
  }
})
export default class FormDenuncias extends Vue {
  $refs: {
    form: Vue & { validate(): boolean; resetValidation(): void; reset(): void }
    magistrado: Vue & {
      validate(): boolean
      resetValidation(): void
      reset(): void
    }
    expediente: Vue & {
      validate(): boolean
      resetValidation(): void
      reset(): void
    }
    juzgado: Vue & {
      focus(): boolean
      resetValidation(): void
      reset(): void
    }
  }

  @Prop({ default: true })
  private showAgregar: boolean

  @Prop({ default: false, type: Boolean })
  private disabled: boolean

  @Prop({ required: true })
  private denuncia!: Denuncia

  @Prop({ default: false, type: Boolean })
  private loading = false

  @Prop({ type: String })
  private errorMessage

  @Prop({ default: false, type: Boolean })
  private error = false

  generateExpDesc(item: Denuncia) {
    return `Exp. ${item.expediente.resolucion.numero}/${item.expediente.resolucion.anio} - "${item.expediente.caratula}"`
  }

  private get tieneA() {
    return this.findSupuesto('A')
  }

  private set tieneA(value) {
    this.modifySupuesto(value, 'A')
  }
  private noTieneSanciones() {
    return (
      !this.localInstance?.sancionResolucion?.numero ||
      !this.localInstance.sancionResolucion.anio
    )
  }
  private noTieneApertura() {
    return (
      !this.localInstance?.aperturaResolucion?.numero ||
      !this.localInstance.aperturaResolucion.anio
    )
  }
  private get itemsTipoComisionSelect() {
    let opciones = mapToSelect(TIPO_COMISION)
    opciones = [
      {
        text: 'Seleccionar',
        value: 'null'
      },
      ...opciones
    ]
    return opciones
  }

  private get tieneB() {
    return this.findSupuesto('B')
  }
  private set tieneB(value) {
    this.modifySupuesto(value, 'B')
  }
  private get tieneC() {
    return this.findSupuesto('C')
  }
  private set tieneC(value) {
    this.modifySupuesto(value, 'C')
  }
  private findSupuesto(unSupuesto: string) {
    return this.localInstance.supuestos.find(
      (supuesto) => supuesto === unSupuesto
    )
  }
  focus() {
    this.$refs.juzgado.focus()
  }
  private modifySupuesto(value, supuesto) {
    value
      ? this.localInstance.supuestos.push(supuesto)
      : this.deleteSupuesto(supuesto)
  }

  private deleteSupuesto(unSupuesto) {
    this.localInstance.supuestos = this.localInstance.supuestos.filter(
      (option) => option !== unSupuesto
    )
  }
  private localInstance: Denuncia = this.denuncia

  @Prop({ type: Boolean, default: false })
  private formDisabled

  private dialog = false

  private checkbox = false

  private valid = true

  private rules = {
    required,
    maxLength2000: maxLength(2000),
    maxLength200: maxLength(200),
    length4: totalLength(4),
    greaterOrEquals2021: greaterOrEquals((): number => 2021),
    maxLength6: maxLength(6),
    lessOrEquals: lessOrEquals(this.calcularMax.bind(this)),
    greater: greaterDates(this.fechaMin.bind(this))
  }

  private get incisoA() {
    return !!this.localInstance.supuestos.find((supuesto) => supuesto === 'A')
  }

  private get incisoB() {
    return !!this.localInstance.supuestos.find((supuesto) => supuesto === 'B')
  }
  private get incisoC() {
    return !!this.localInstance.supuestos.find((supuesto) => supuesto === 'C')
  }
  calcularMax(): number | undefined {
    return new Date().getUTCFullYear()
  }
  imprimirResolucion(resolucion: Resolucion) {
    resolucion.numero && resolucion.anio
      ? `${resolucion.numero} / ${resolucion.anio}`
      : ''
  }

  private show = true
  fechaMin() {
    const value = {
      value: convertFechaInicio('07-03-2021').getTime(),

      message: 'La fecha de fin de convocatoria debe ser mayor al 07-03-2021'
    }
    return value
  }
  private get minFin() {
    return convertFechaInicio('07-03-2021').toISOString()
  }
  private get maxDate() {
    return new Date().toISOString()
  }
  private get max() {
    return convertFechaInicio('07-03-2021').toISOString()
  }
  private async newInstance() {
    await this.$emit('newInstance')
    await this.resetValidation()
    await this.$nextTick(this.openDialog)
  }
  private generarReporte() {
    this.$emit('generarReporte')
  }

  resetValidation() {
    this.$refs.form.resetValidation()
    if (!this.disabled) this.$refs.magistrado.resetValidation()
    this.$refs.expediente.resetValidation()
  }
  showFecha(date: string) {
    return date ? showFecha(date) : ''
  }
  reset() {
    this.$refs.form.reset()
    if (!this.disabled) this.$refs.magistrado.reset()
    this.$refs.expediente.reset()
  }

  onClose() {
    this.dialog = false
    this.$nextTick(this.reset)
  }

  async openDialog() {
    await this.onEntidadChange()
    this.dialog = true
  }

  validate() {
    return (
      (this.disabled || this.$refs.magistrado.validate()) &&
      this.$refs.form.validate() &&
      this.$refs.expediente.validate()
    )
  }

  onSave() {
    if (this.validate()) {
      if (!this.incisoA && !this.incisoB && !this.incisoC) {
        this.onError('Debe elegir al menos un supuesto')
      } else if (this.localInstance.expediente.id) {
        this.$emit('save', this.localInstance)
      } else this.onError('No se encuentra un expediente cargado')
    }
  }
  onError(error: string) {
    this.$emit('error', error)
  }

  @Watch('denuncia')
  private onEntidadChange() {
    if (this.denuncia) {
      this.localInstance = JSON.parse(JSON.stringify(this.denuncia))
    }
  }
}
